import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
	IPasswordValidationFields,
	PasswordValidationFields,
	PasswordValidator,
} from '../../../globals/classes/password-validator';
import { AppSettings } from '../../app.settings';
import { ChangePasswordRequest } from '../../classes/change-password';
import { InitializePasswordRequest } from '../../classes/initialize-password';

@Component({
	selector: 'set-password',
	template: require('./set-password.component.html'),
})
export class SetPasswordComponent implements OnInit {
	@Input() passwordInfo: InitializePasswordRequest | ChangePasswordRequest;
	@Input() isNewChangePasswordModals: boolean = false;

	public validation: IPasswordValidationFields;
	public isPasswordVisible: boolean = false;
	public isConfirmPasswordVisible: boolean = false;

	public get password(): string {
		if (this.passwordInfo instanceof InitializePasswordRequest) {
			return this.passwordInfo.passwordNew;
		} else if (this.passwordInfo instanceof ChangePasswordRequest) {
			return this.passwordInfo.newPassword;
		}
	}

	public get passwordConfirmation(): string {
		if (this.passwordInfo instanceof InitializePasswordRequest) {
			return this.passwordInfo.passwordConfirmNew;
		} else if (this.passwordInfo instanceof ChangePasswordRequest) {
			return this.passwordInfo.newPasswordConfirm;
		}
	}

	public set password(value: string) {
		if (this.passwordInfo instanceof InitializePasswordRequest) {
			this.passwordInfo.passwordNew = value;
		} else if (this.passwordInfo instanceof ChangePasswordRequest) {
			this.passwordInfo.newPassword = value;
		}
	}

	public set passwordConfirmation(value: string) {
		if (this.passwordInfo instanceof InitializePasswordRequest) {
			this.passwordInfo.passwordConfirmNew = value;
		} else if (this.passwordInfo instanceof ChangePasswordRequest) {
			this.passwordInfo.newPasswordConfirm = value;
		}
	}

	ngOnInit() {
		this.validation = new PasswordValidationFields();
		if (!!this.password) {
			this.validatePassword(this.password);
		}
		if (!!this.passwordConfirmation) {
			this.validateConfirmPassword(this.passwordConfirmation);
		}
	}

	public validatePassword(value: string) {
		this.validation = Object.assign({}, PasswordValidator.checkFields(value));
		if (!!this.passwordConfirmation) {
			this.validateConfirmPassword(this.passwordConfirmation);
		}
	}

	public validateConfirmPassword(value: string) {
		this.validation = Object.assign(
			{},
			PasswordValidator.CheckPasswordConfirmation(value, this.password)
		);
	}

	public toggleVisibility() {
		this.isPasswordVisible = !this.isPasswordVisible;
	}

	public toggleConfirmVisibility() {
		this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
	}
}
